import { useEffect, useState } from 'react';
import { isStandalone } from './push';

// Chrome/Edge fire beforeinstallprompt once, often before the settings page
// mounts: the event is kept here from startup (imported by index.js).

let deferred = null;
const listeners = new Set();
const notify = () => listeners.forEach((fn) => fn());

export const listenForInstallPrompt = () => {
  if (typeof window === 'undefined') return;
  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    deferred = event;
    notify();
  });
  window.addEventListener('appinstalled', () => {
    deferred = null;
    notify();
  });
};

export const useInstallPrompt = () => {
  const [, setTick] = useState(0);
  useEffect(() => {
    const fn = () => setTick((n) => n + 1);
    listeners.add(fn);
    return () => listeners.delete(fn);
  }, []);
  const install = async () => {
    if (!deferred) return false;
    const event = deferred;
    deferred = null;
    notify();
    await event.prompt();
    const choice = await event.userChoice;
    return choice?.outcome === 'accepted';
  };
  return { installed: isStandalone(), canInstall: Boolean(deferred), install };
};

// Test hook: simulates the browser offering the install.
export const setDeferredPromptForTest = (event) => {
  deferred = event;
  notify();
};
